import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrown, faRefresh, faArrowLeft } from '@/fontawesome';

interface FullscreenErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  onBack?: () => void;
  showRetry?: boolean;
  showBack?: boolean;
}

export default function FullscreenError({
  title = 'Etwas ist schiefgelaufen',
  message = 'Die Seite konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  onRetry,
  onBack,
  showRetry = true,
  showBack = true
}: FullscreenErrorProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 text-center max-w-md w-full">
        <div className="text-6xl mb-6">
          <FontAwesomeIcon icon={faFrown} className="text-gray-400" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          {title}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
          {message}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showRetry && onRetry && (
            <button
              onClick={onRetry}
              className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
            >
              <FontAwesomeIcon icon={faRefresh} className="w-4 h-4 mr-2" />
              Erneut versuchen
            </button>
          )}
          {showBack && onBack && (
            <button
              onClick={onBack}
              className="inline-flex items-center px-6 py-3 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-lg transition-colors"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="w-4 h-4 mr-2" />
              Zurück
            </button>
          )}
        </div>
        <div className="mt-6 text-sm text-gray-500 dark:text-gray-400">
          Falls das Problem weiterhin besteht, kontaktieren Sie den Administrator.
        </div>
      </div>
    </div>
  );
}